import { device_px, gray, primary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_767 } = device_px

export const UserActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  gap: 15px;
  height: 60px;
  margin-top: 30px;
  @media screen and (max-width: ${MAX_767}) {
    min-width: 280px;
  }
`

export const UserGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`

export const UserDescription = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 10px;
`

export const UserName = styled.span`
  overflow: hidden;
  color: ${primary.black};
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const UserDepartment = styled.span`
  overflow: hidden;
  color: ${gray[55]};
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`
